<template>
  <div class="container">
    <!-- Card Farmasi Pending -->
    <div class="card-scroll-wrapper" v-if="pendingFarmacies.length">
      <div class="card-list">
        <div
          class="doctor-card"
          v-for="farmasi in pendingFarmacies"
          :key="farmasi.id"
          @click="openDetailModal(farmasi)"
        >
          <h4>{{ farmasi.name }}</h4>
          <p style="color: #888">{{ farmasi.location }}</p>
          <a-tag color="blue">Perlu Persetujuan</a-tag>
        </div>
      </div>
    </div>

    <a-input-search
      v-model:value="search"
      placeholder="Cari Farmasi"
      enter-button
      style="margin: 16px 0"
    />

    <div style="margin-bottom: 8px">Urutkan melalui</div>
    <a-radio-group v-model:value="statusFilter" style="margin-bottom: 16px">
      <a-radio-button value="all">Disetujui & Ditolak</a-radio-button>
      <a-radio-button value="Disetujui">Disetujui</a-radio-button>
      <a-radio-button value="Ditolak">Ditolak</a-radio-button>
    </a-radio-group>

    <a-table
      class="responsive-table"
      :columns="columns"
      :data-source="filteredFarmacies"
      :pagination="{ pageSize: 10 }"
      :scroll="{ x: 620 }"
      row-key="id"
      @row-click="openDetailModal"
    >
      <template #status="{ text }">
        <span :style="{ color: text ? '#52c41a' : '#f5222d' }">{{
          text ? 'Disetujui' : 'Ditolak'
        }}</span>
      </template>
    </a-table>

    <a-modal
      v-model:visible="visible"
      :title="'DETAIL FARMASI'"
      :footer="null"
      @cancel="visible = false"
    >
      <div class="doctor-detail-card">
        <h3>{{ selectedFarmasi?.name }}</h3>
        <p style="color: #999; margin-top: -8px">{{ selectedFarmasi?.location }}</p>
      </div>

      <div class="row doctor-detail-grid mt-4">
        <div class="col-6 mb-2"><strong>Alamat Farmasi</strong><br /></div>
        <div class="col-6 mb-2">: {{ selectedFarmasi?.address }}</div>
      </div>

      <div v-if="!selectedFarmasi?.status" class="doctor-detail-actions">
        <a-button
          type="primary"
          style="background: linear-gradient(to right, #f2994a, #f2c94c); border: none"
        >
          DISETUJUI
        </a-button>
        <a-button danger>
          TIDAK DISETUJUI
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { getFarmasi } from '../../services/axios/pulih/index'
export default {
  setup() {
    const search = ref('')
    const statusFilter = ref('all')
    const visible = ref(false)
    const selectedFarmasi = ref(null)
    const pendingFarmasi = ref([])
    const dataFarmasi = ref([])

    const farmacies = ref([
      {
        id: 1,
        name: 'MRCCC Siloam Hospital',
        location: 'DKI Jakarta',
        address: 'Jl. Garnisun Dalam No. 2-3, Jakarta Selatan 12930',
        certificate: '',
        status: 'Disetujui',
      },
      {
        id: 2,
        name: 'RS Mangusada',
        location: 'Bali',
        address: 'Jalan Raya Kapal, Mengwi, Badung, Bali 80351',
        certificate: '',
        status: 'Disetujui',
      },
      {
        id: 3,
        name: 'RS Dr. Oen Kendang Sapi',
        location: 'Solo',
        address: 'Jl. Mayor Kusmanto No. 1, Solo',
        certificate: '',
        status: 'Disetujui',
      },
      {
        id: 4,
        name: 'Satya Farma',
        location: 'Surabaya',
        address: 'Jl. A. Yani No. 88, Surabaya',
        certificate: '',
        status: 'Disetujui',
      },
      {
        id: 5,
        name: 'RSU Borromeus',
        location: 'Bandung',
        address: 'Jl. Ir. H. Juanda No.100, Bandung',
        certificate: '',
        status: 'Ditolak',
      },
      {
        id: 6,
        name: 'Apotek Karya Husada',
        location: 'Tangerang',
        address: 'Jl. Raya Serpong No.12, Tangerang',
        certificate: '',
        status: '',
      },
      {
        id: 7,
        name: 'Apotek Citra Farma',
        location: 'Bekasi',
        address: 'Jl. Jendral Sudirman No.45, Bekasi',
        certificate: '',
        status: '',
      },
    ])

    const columns = [
      { title: 'Nama', dataIndex: 'name', key: 'name' },
      { title: 'Lokasi', dataIndex: 'city', key: 'location' },
      {
        title: 'Status',
        dataIndex: 'isApproved',
        key: 'status',
        slots: { customRender: 'status' },
      },
    ]

    const pendingFarmacies = computed(() => farmacies.value.filter(f => !f.status))

    const filteredFarmacies = computed(() => {
      return farmacies.value.filter(f => {
        // 1. Filter item yang sudah memiliki status (bukan pending)
        if (f.isApproved === null) {
          return false
        }

        // 2. Filter berdasarkan keyword pencarian
        const matchesSearch = f.name.toLowerCase().includes(search.value.toLowerCase())

        // 3. Filter berdasarkan status yang dipilih
        let matchesStatus = false
        if (statusFilter.value === 'all') {
          matchesStatus = true // Jika 'all', loloskan semua status
        } else if (statusFilter.value === 'Disetujui') {
          matchesStatus = f.isApproved === true // Bandingkan dengan boolean true
        } else if (statusFilter.value === 'Ditolak') {
          matchesStatus = f.isApproved === false // Bandingkan dengan boolean false
        }

        return matchesSearch && matchesStatus
      })
    })

    const openDetailModal = farmasi => {
      selectedFarmasi.value = farmasi
      visible.value = true
    }
    const fetchData = async () => {
      const { data } = await getFarmasi()
      pendingFarmacies.value = data.filter(e => e.isApproved === null)
      farmacies.value = data.filter(e => e.isApproved !== null)
      // console.log(pendingFarmacies.value, 'inigimana')
      // console.log(dataFarmasi.value, 'inigimana2')
    }
    onMounted(() => {
      fetchData()
    })

    return {
      search,
      statusFilter,
      visible,
      selectedFarmasi,
      farmacies,
      columns,
      filteredFarmacies,
      pendingFarmacies,
      openDetailModal,
      fetchData,
    }
  },
}
</script>

<style scoped>
.container {
  /* max-width: 800px; */
  margin: 0 auto;
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.card-scroll-wrapper {
  overflow-x: auto;
  margin-bottom: 16px;
}
.card-list {
  display: flex;
  gap: 16px;
  min-width: max-content;
}
.doctor-card {
  border: 2px solid #9b1c7b;
  border-radius: 12px;
  padding: 12px 16px;
  min-width: 240px;
  text-align: center;
  background: #fdfcff;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.doctor-card:hover {
  /* transform: translateY(-2px); */
}
.doctor-detail-card {
  text-align: center;
  margin-bottom: 16px;
}
.doctor-detail-grid {
  margin-bottom: 16px;
}
.doctor-detail-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
}

.responsive-table {
  width: 100%;
}

:global(.responsive-table .ant-table-content) {
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
}

:global(.responsive-table .ant-table-thead > tr > th),
:global(.responsive-table .ant-table-tbody > tr > td) {
  white-space: nowrap;
}

:global(.responsive-table .ant-pagination) {
  flex-wrap: wrap;
  row-gap: 8px;
}

@media (max-width: 576px) {
  .container {
    padding: 16px 12px;
    border-radius: 0;
    box-shadow: none;
  }

  .doctor-card {
    min-width: 200px;
    padding: 12px;
  }

  :global(.responsive-table .ant-table-thead > tr > th),
  :global(.responsive-table .ant-table-tbody > tr > td) {
    padding: 10px 12px;
    font-size: 12px;
  }

  :global(.responsive-table .ant-pagination) {
    justify-content: center;
  }
}
</style>
